import React, { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import api from "../../utils/api";
import ManageTablesModal from "../../components/TableBooking/ManageTablesModal";
import AddTableModal from "../../components/TableBooking/AddTableModal";
import ViewQrModal from "../../components/TableBooking/ViewQrModal";
import IncomingQrRequests from "../../components/TableBooking/IncomingQrRequests";
import socket from "../../socket";


import { toast } from "react-toastify";

const QrBookingPage = () => {
    const [openManage, setOpenManage] = useState(false);
    const [openForm, setOpenForm] = useState(false);
    const [selectedTable, setSelectedTable] = useState(null);
    const [openQr, setOpenQr] = useState(false);
    const [qrTable, setQrTable] = useState(null);
    const [requests, setRequests] = useState([]);
    const [reqLoading, setReqLoading] = useState(false);
    const [tables, setTables] = useState([]);
    const [loading, setLoading] = useState(false);

    const restaurantId = process.env.REACT_APP_DEFAULT_RESTAURANT_ID;
    useEffect(() => {
        if (!restaurantId) return;

        socket.emit("joinRestaurant", {
            restaurantId,
        });

        const handleQrRequestCreated = (newRequest) => {
            setRequests((prev) => [newRequest, ...prev]);

            toast.info(
                `New QR request for Table ${newRequest.tableId?.tableNumber ?? "Unknown"}`
            );
        };

        const handleQrRequestUpdated = () => {
            fetchRequests();
        };

        socket.on("qr-request-created", handleQrRequestCreated);
        socket.on("qr-request-accepted", handleQrRequestUpdated);
        socket.on("qr-request-rejected", handleQrRequestUpdated);

        return () => {
            socket.off("qr-request-created", handleQrRequestCreated);
            socket.off("qr-request-accepted", handleQrRequestUpdated);
            socket.off("qr-request-rejected", handleQrRequestUpdated);
        };
    }, [restaurantId]);


    const fetchTables = async () => {
        setLoading(true);
        try {
            const res = await api.get("/table/tables", {
                params: { restaurantId },
            });
            setTables(res.data);
        } catch (err) {
            toast.error("Failed to load tables");
        } finally {
            setLoading(false);
        }
    };
    const handleBulkPrintDirect = () => {
        const printContainer = document.createElement("div");
        printContainer.id = "qr-bulk-print";

        printContainer.innerHTML = `
    <style>
      @media print {
        body * {
          visibility: hidden;
        }
        #qr-bulk-print, #qr-bulk-print * {
          visibility: visible;
        }
        #qr-bulk-print {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          padding: 20px;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 24px;
          font-family: Arial, sans-serif;
        }
        .qr-item {
          text-align: center;
          page-break-inside: avoid;
        }
        svg {
          width: 160px;
          height: 160px;
        }
      }
    </style>
    ${tables
                .map(
                    (t) => `
          <div class="qr-item">
            <h4>Table ${t.tableNumber}</h4>
            ${t.qrImage || ""}
          </div>
        `
                )
                .join("")}
  `;

        document.body.appendChild(printContainer);
        window.print();
        document.body.removeChild(printContainer);
    };


    const createOrUpdateTable = async ({ _id, tableNumber, capacity }) => {
        try {
            if (_id) {
                await api.put(`/table/update/${_id}`, {
                    tableNumber,
                    capacity,
                    restaurantId,
                });
                toast.success("Table updated successfully");
            } else {
                await api.post("/table/create", {
                    tableNumber,
                    capacity,
                    restaurantId,
                    generateQr: true,
                });
                toast.success("Table created successfully");
            }

            await fetchTables();
            return true;
        } catch (err) {
            const message =
                err?.response?.data?.message || "Something went wrong";
            toast.error(message);
            return false;
        }
    };


    useEffect(() => {
        if (restaurantId) fetchTables();
    }, [restaurantId]);

    const handleViewQr = (table) => {
        setQrTable(table);
        setOpenQr(true);
    };
    const fetchRequests = async () => {
        try {
            setReqLoading(true);
            const res = await api.get("/table/recevied-requests", {
                params: { restaurantId },
            });
            setRequests(res.data);
        } catch {
            toast.error("Failed to load QR requests");
        } finally {
            setReqLoading(false);
        }
    };
    const handleRequestAction = async (id, action) => {
        try {
            await api.post(`/table-access/${id}/${action}`);
            toast.success(`Request ${action}ed`);
            fetchRequests();
        } catch {
            toast.error("Action failed");
        }
    };

    useEffect(() => {
        if (restaurantId) {
            fetchTables();
            fetchRequests();
        }
    }, [restaurantId]);

    return (
        <Box sx={{ p: 2 }}>
            <h1 style={{ fontWeight: 700, marginBottom: 24 }}>
                QR Booking
            </h1>

            <Button
                variant="contained"
                onClick={() => setOpenManage(true)}
            >
                Table Manage
            </Button>

            {/* MANAGE TABLES */}
            <ManageTablesModal
                open={openManage}
                onClose={() => setOpenManage(false)}
                tables={tables}
                loading={loading}
                onAdd={() => {
                    setSelectedTable(null);
                    setOpenManage(false);
                    setOpenForm(true);
                }}
                onEdit={(table) => {
                    setSelectedTable(table);
                    setOpenManage(false);
                    setOpenForm(true);
                }}
                onViewQr={handleViewQr}
                onBulkPrint={handleBulkPrintDirect}
            />

            {/* ADD / EDIT TABLE */}
            <AddTableModal
                open={openForm}
                onClose={() => setOpenForm(false)}
                mode={selectedTable ? "edit" : "add"}
                initialData={selectedTable}
                onSave={createOrUpdateTable}
            />
            <ViewQrModal
                open={openQr}
                onClose={() => {
                    setOpenQr(false);
                    setQrTable(null);
                }}
                table={qrTable}
            />
            <Box sx={{ mt: 4 }}>
                <h2 style={{ marginBottom: 16 }}>
                    Incoming  Requests
                </h2>

                <IncomingQrRequests
                    requests={requests}
                    loading={reqLoading}
                    onAccept={(id) => handleRequestAction(id, "accept")}
                    onReject={(id) => handleRequestAction(id, "reject")}
                />
            </Box>
        </Box>


    );
};

export default QrBookingPage;
